import { ICategory } from 'store/api'

type Props = {
  category: ICategory
}
const CategoryDetails = ({ category }: Props) => {
  return (
    <div className='hidden lg:block mb-24'>
      <div
        itemProp='description'
        className='text-base2 text-bodyGrey leading-snug font-light my-6'
        dangerouslySetInnerHTML={{
          __html: category.text,
        }}
      ></div>
    </div>
  )
}

export default CategoryDetails
